/*
  Shareable renderer for displaying the name of a device.
  Largely a copy/paste from the original table column.
*/
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React from 'react';
import { observer } from 'mobx-react';
import { Flex, Tag, Text } from 'core/components';
import DeviceModel from 'app/stores/device/DeviceModel';
import LabelList from 'app/components/labels/LabelList';
import DeviceLink from 'app/components/links/DeviceLink';
import DeviceClassIcon from 'app/components/nms/DeviceClassIcon';

interface Props {
  model: DeviceModel;
  showLabels: boolean;
}

function DeviceNameRenderer({ model, showLabels = false }: Props) {
  const icon = <DeviceClassIcon deviceModel={model} fillSpaceIfNull showTooltip tooltipPosition="top" iconSize={24} />;

  return (
    <Flex flexDirection="column">
      <Flex>
        <DeviceLink name={model.get('device_name')}>
          <Flex gap="4px" alignItems="center">
            {icon}
            <Text ellipsis fontWeight="bold">
              {model.get('device_name')}
            </Text>
          </Flex>
        </DeviceLink>
        {!model.isActive && (
          <Tag ml="4px" minimal small intent="warning">
            {model.isArchived ? 'Archived' : 'Incomplete'}
          </Tag>
        )}
      </Flex>
      {showLabels && (
        <LabelList
          my="2px"
          labels={model.get('labels')}
          priorityLabels={model.collection.discreteFilterValues.label}
          fixedWidth
          maxLabelsToShow={2}
        />
      )}
    </Flex>
  );
}

export default observer(DeviceNameRenderer);
